import RegenTemplatesEdit from '@/components/configs/regen/templates/edit/RegenTemplatesEdit.vue'
import MessageBox from '@/components/common/messagebox/MessageBox.vue';
import { mapState } from 'vuex';

export default {
  name: 'DrnTemplatesList',
  data () {
    return {
      queueAdd: {
        el: null,
        loading: false,
        regenerateAll: false
      },
      isMounted: false,
      loading: true,
      filterValues: [],
      items: [],
      paging: {
        page: 1,
        pages: 1,
        limit: 30,
        total: 0
      }
    }
  },
  components: {
    RegenTemplatesEdit,
    MessageBox
  },
  computed: {
    ...mapState(['config']),
    tableHeaders () {
      const headers = [
        { key: 'pdf_template_id', label: this.$t('regen-template.pdf-template'), format: 'formatFromConfig', configKey: 'pdf_templates', configParam: 'code', nolocale: true },
        { key: 'material_group_id', label: this.$t('material-group.title'), format: 'formatFromConfig', configKey: 'material_groups', configParam: 'name' },
        { key: 'year', label: this.$t('regen-template.year') },
        { key: 'number', label: this.$t('regen-template.info.number') },
        { key: 'info.' + this.$i18n.locale, label: this.$t('regen-template.info.title'), format: 'formatJsonTranslations', trasnkey: 'regen-template.info.' }
      ];
      const actions = [
        { label: this.$t('menu.config.regen-templates.test'), emit: 'testItem', bicon: 'file-ppt', class: 'btn-download' }
      ];
      if (this.canEdit) {
        actions.unshift({ label: this.$t('menu.config.regen-templates.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' });
        actions.push({ label: this.$t('menu.config.regen-templates.queue'), emit: 'queueItem', bicon: 'clipboard-plus', class: 'btn-primary' });
        actions.push({ label: this.$t('menu.config.regen-templates.delete'), emit: 'deleteItem', bicon: 'trash', class: 'btn-delete' });
      }
      headers.push({ key: 'actions', label: '', actions: actions })
      return headers;
    },
    tableActions () {
      const actions = { };
      if (this.canEdit) {
        actions.add = { title: this.$t('menu.config.regen-templates.new') };
      }
      return actions;
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-settings');
    },
    tableExpandConfig () {
      return { component: 'RegenTemplatesListExpand' };
    }
  },
  methods: {
    changePage (page, key) {
      this.paging.page = page;
      this.getTableData();
    },
    getTableData () {
      const self = this;
      this.loading = true;
      this.ApiRequest.request('regen-templates/list?perPage=' + this.paging.limit + '&page=' + this.paging.page, this.ApiRequest.REQUEST_GET, [], function (response) {
        if (response.data) {
          self.items = response.data;
          self.paging = response.paging;
        }
        self.loading = false;
      });
    },
    deleteItem (el, approved = false) {
      if (approved) {
        const self = this;
        this.ApiRequest.request('regen-templates/' + el.id + '/delete', this.ApiRequest.REQUEST_POST, [], function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.getTableData()
          }
        });
      } else {
        this.$refs.deleteElMsgBox.show(
          el,
          this.$t('menu.config.regen-templates.delete'),
          this.$t('menu.config.regen-templates.delete-message', {
            year: el.year,
            material_group: this.$options.filters.formatFromConfig(el.material_group_id, this.config.material_groups, 'name', this.$i18n.locale)
          })
        );
      }
    },
    queueItem (el, approved) {
      if (approved) {
        const self = this;
        self.queueAdd.loading = true;
        this.ApiRequest.request('regen-templates/' + this.queueAdd.el.id + '/queue', this.ApiRequest.REQUEST_POST, { regenerateAll: this.queueAdd.regenerateAll }, function (response) {
          if (response.data) {
            self.$refs.queueFrom.hide();
            self.ApiRequest.displaySuccessDialog(self, 'regen-template.add-to-queue.success', 'menu.config.regen-templates.queue');
          } else {
            self.ApiRequest.displayErrorDialog(response, self);
          }
          self.queueAdd.loading = false;
        });
      } else {
        this.queueAdd.el = el;
        this.queueAdd.regenerateAll = false;
        this.$refs.queueFrom.show();
      }
    },
    closeQueueItem () {
      this.$refs.queueFrom.hide();
    },
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    testItem (el) {
      this.ApiRequest.request('regen-templates/' + el.id + '/test-pdf', this.ApiRequest.REQUEST_DOWNLOAD, [], function (response) {
      });
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    this.isMounted = true;
    this.getTableData();
  }
}
